import File from "./File.vue"
export default File